export default "__VITE_ASSET__CHR9HNH1__"